import { CheckCircle, Download, Clock } from "lucide-react";
import { useMyLifecycleState } from "@/hooks/useMyLifecycleState";
import { Button } from "@/components/ui/button";
import { differenceInDays, format } from "date-fns";
import { useNavigate } from "react-router-dom";

export function CompletedAccessBanner() {
  const { data: lifecycleData, isLoading } = useMyLifecycleState();
  const navigate = useNavigate();

  // Only show for completed state that hasn't expired
  // (expired completed leaders should see ArchivedAccessBanner via effective_state)
  if (isLoading || lifecycleData?.lifecycle_state !== "completed" || lifecycleData?.access_expired) {
    return null;
  }

  const accessEndsAt = lifecycleData.access_ends_at 
    ? new Date(lifecycleData.access_ends_at) 
    : null;
  
  const daysRemaining = accessEndsAt 
    ? Math.max(0, differenceInDays(accessEndsAt, new Date()))
    : 0;

  return (
    <div className="bg-muted border-b border-border px-5 py-4">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-start gap-3 flex-1">
          <CheckCircle className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
          <div className="space-y-1">
            <p className="text-small font-medium text-foreground">
              Your coaching engagement has been completed
            </p>
            <p className="text-small text-muted-foreground">
              You have read-only access to review your journey. 
              {accessEndsAt && (
                <>
                  {" "}Access ends {format(accessEndsAt, "MMMM d, yyyy")}.
                </>
              )}
            </p>
            {lifecycleData.closing_note && (
              <p className="text-small text-muted-foreground italic mt-2 border-l-2 border-primary/30 pl-3">
                "{lifecycleData.closing_note}"
              </p>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-3 sm:flex-shrink-0">
          {/* Countdown indicator */}
          <div className="flex items-center gap-1.5 text-small text-muted-foreground bg-background px-3 py-1.5 rounded-full">
            <Clock className="h-4 w-4" />
            <span>{daysRemaining} days remaining</span>
          </div>
          
          {/* Download button */}
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => navigate("/settings?tab=data")}
            className="gap-2"
          >
            <Download className="h-4 w-4" />
            Download Data
          </Button>
        </div>
      </div>
    </div>
  );
}
